<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <OffsetTemp />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import OffsetTemp from '@/components/settings/arena/vei-off-temp/OffsetTemp'

export default {
  name: 'OffsetTempView',
  components: {
    PageTitle,
    PageRowWrapper,
    OffsetTemp
  }
}
</script>
